import React, { useState } from "react";

const ApiTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testApi = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      console.log("🧪 API TEST: Starting test");
      const response = await fetch('http://localhost:5000/cart/68ded148cbfe892dc87f3c45');
      console.log("🧪 API TEST: Response status:", response.status);
      
      const data = await response.json();
      console.log("🧪 API TEST: Response data:", data);
      
      setResult({
        status: response.status,
        ok: response.ok,
        data: data,
        itemsCount: data?.items?.length || 0
      });
    } catch (error) {
      console.error("🧪 API TEST: Error:", error);
      setResult({
        error: error.message,
        type: 'network_error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">API Test</h1>
        
        <div className="bg-white p-6 rounded-lg shadow-md mb-6">
          <h2 className="text-xl font-semibold mb-4">Cart API Test</h2>
          <p className="text-gray-600 mb-4">
            Testing direct API call to: <code>http://localhost:5000/cart/68ded148cbfe892dc87f3c45</code>
          </p>
          
          <button
            onClick={testApi}
            disabled={loading}
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test API'}
          </button>
        </div>

        {result && (
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-4">Test Results:</h3>
            
            {result.error ? (
              <div className="text-red-600">
                <p><strong>Error:</strong> {result.error}</p>
                <p><strong>Type:</strong> {result.type}</p>
              </div>
            ) : (
              <div>
                <p><strong>Status:</strong> {result.status}</p>
                <p><strong>Success:</strong> {result.ok ? 'Yes' : 'No'}</p>
                <p><strong>Items Count:</strong> {result.itemsCount}</p>
                
                {result.data && (
                  <div className="mt-4">
                    <h4 className="font-semibold mb-2">Raw Response:</h4>
                    <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-96">
                      {JSON.stringify(result.data, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApiTest;
